import { cn } from '@/shadcn-ui/utils';

interface PlanSelectionPanelContainerProps {
  className?: string;
  children: React.ReactNode;
  dataTestId?: string;
}

export default function PlanSelectionPanelContainer({
  className,
  children,
  dataTestId,
}: PlanSelectionPanelContainerProps) {
  return (
    <div
      className={cn(
        'flex flex-col rounded-[32px] bg-flexcar-neutral100 pt-[24px] shadow-shadow25 lg:shadow-none',
        className
      )}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
}
